import { useChangePasswordMutation } from "../../redux/services/auth/registerAPI";
import { useFormik } from "formik";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from 'sweetalert2';

export default function ChangePassword({ handleUserChange }) {
  const location = useLocation();
  const data = location;
  const [ChangePassword] = useChangePasswordMutation();
  const navigate = useNavigate();

  const form = useFormik({
    initialValues: { password: "", repassword: "" },
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      const response = await ChangePassword({
        id: data?.state?.user?.id,
        password: String(values.password),
      });

      if (response?.data) {
        Swal.fire({ icon: 'success', text: response.data || 'Password updated', timer: 1600, showConfirmButton: false, customClass: { popup: 'sweetalert2-custom-popup' } });
        navigate('/dashboard');
      } else {
        Swal.fire({ icon: 'warning', text: response?.error?.data || 'Unable to update password.', confirmButtonText: 'OK', customClass: { popup: 'sweetalert2-custom-popup' } });
      }

      resetForm();
      setTimeout(() => setSubmitting(false), 300);
    },
    validate: (values) => {
      const errors = {};
      if (!values.password) errors.password = 'Password is required';
      if (!values.repassword) errors.repassword = 'Please confirm your password';
      if (values.password !== values.repassword) errors.repassword = 'Passwords do not match';
      return errors;
    }
  });

  const fieldClass = (name) => `field ${form.errors[name] && form.touched[name] ? 'border-red-300 ring-4 ring-red-50' : ''}`;

  return (
    <section className="bg-surface py-12 sm:py-16">
      <div className="section-shell max-w-3xl">
        <div className="premium-card bg-white p-6 sm:p-8">
          <span className="eyebrow">Security</span>
          <h1 className="section-title mt-5">Change password</h1>
          <p className="section-copy">Use a strong password to keep your bookings and personal details secure.</p>

          <form onSubmit={form.handleSubmit} className="mt-8 space-y-5">
            <label><span className="mb-2 block text-xs font-bold uppercase tracking-wide text-muted">New password</span><input className={fieldClass('password')} name="password" type="password" value={form.values.password} onChange={form.handleChange} onBlur={form.handleBlur} /></label>
            {form.errors.password && form.touched.password && <p className="text-sm font-bold text-red-500">{form.errors.password}</p>}

            <label><span className="mb-2 block text-xs font-bold uppercase tracking-wide text-muted">Confirm password</span><input className={fieldClass('repassword')} name="repassword" type="password" value={form.values.repassword} onChange={form.handleChange} onBlur={form.handleBlur} /></label>
            {form.errors.repassword && form.touched.repassword && <p className="text-sm font-bold text-red-500">{form.errors.repassword}</p>}

            <div className="flex justify-end gap-3">
              <button type="button" onClick={() => window.history.back()} className="btn-secondary">Cancel</button>
              <button type="submit" disabled={form.isSubmitting} className="btn-primary">{form.isSubmitting ? 'Loading...' : 'Update password'}</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}
